import { render, staticRenderFns } from "./EditTodoItem.vue?vue&type=template&id=735812a9"
import script from "./EditTodoItem.vue?vue&type=script&lang=js"
export * from "./EditTodoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports